import { usePopup } from '@/shared/composables/usePopup';

let popupInstance = null;

/**
 * Initialize popup helpers to override native alert() and confirm()
 */
export function initializePopupHelpers() {
  if (popupInstance) {
    return; // Already initialized
  }

  popupInstance = usePopup();

  // Override native alert()
  if (typeof window !== 'undefined') {
    const originalAlert = window.alert;
    window.alert = async (message) => {
      await popupInstance.showAlert(message, {
        type: 'info',
        title: 'Alert'
      });
    };
  }
}

/**
 * Show an alert popup
 * @param {string} message - The message to display
 * @param {object} options - Options for the alert
 * @returns {Promise<boolean>} - Resolves when the alert is closed
 */
export async function showAlert(message, options = {}) {
  if (!popupInstance) {
    popupInstance = usePopup();
  }
  return await popupInstance.showAlert(message, options);
}

/**
 * Show a confirmation popup
 * @param {string} message - The message to display
 * @param {object} options - Options for the confirmation
 * @returns {Promise<boolean>} - Resolves with true if confirmed, false if cancelled
 */
export async function showConfirm(message, options = {}) {
  if (!popupInstance) {
    popupInstance = usePopup();
  }
  return await popupInstance.showConfirm(message, options);
}

/**
 * Replace native confirm() with custom popup
 * This is a drop-in replacement for window.confirm()
 */
export async function confirm(message, options = {}) {
  return await showConfirm(message, {
    type: 'warning',
    title: 'Confirm',
    confirmText: 'OK',
    cancelText: 'Cancel',
    confirmVariant: 'primary',
    ...options
  });
}

